/* This file was generated automatically. Do not edit manually. */

export enum IntegrationDataType {
    DeletedIntegration = 'DeletedIntegration',
    ResDiaryIntegration = 'ResDiaryIntegration',
    AlternativePaymentMethodIntegration = 'AlternativePaymentMethodIntegration',
    QrCodePaymentIntegration = 'QrCodePaymentIntegration',
    MerchantIntegration = 'MerchantIntegration',
    BraintreeIntegration = 'BraintreeIntegration',
    AdyenDirectIntegration = 'AdyenDirectIntegration',
    AdyenIntegration = 'AdyenIntegration',
    SynthexFiscalRegistryIntegration = 'SynthexFiscalRegistryIntegration',
    SwedishFiscalRegistryIntegration = 'SwedishFiscalRegistryIntegration',
    SpanishFiscalRegistryIntegration = 'SpanishFiscalRegistryIntegration',
    ItalianFiscalPrinterIntegration = 'ItalianFiscalPrinterIntegration',
    ItalianFiscalRegistryIntegration = 'ItalianFiscalRegistryIntegration',
    HungarianFiscalRegistryIntegration = 'HungarianFiscalRegistryIntegration',
    GermanFiscalRegistryIntegration = 'GermanFiscalRegistryIntegration',
    GermanXrechnungIntegration = 'GermanXrechnungIntegration',
    EetFiscalRegistryIntegration = 'EetFiscalRegistryIntegration',
    ChainingFiscalRegistryIntegration = 'ChainingFiscalRegistryIntegration',
    BasqueFiscalRegistryIntegration = 'BasqueFiscalRegistryIntegration',
    BelgianTouristBoardExportIntegration = 'BelgianTouristBoardExportIntegration',
    IneOccupancyExportIntegration = 'IneOccupancyExportIntegration',
    IstacOccupancyExportIntegration = 'IstacOccupancyExportIntegration',
    CzechPoliceExportIntegration = 'CzechPoliceExportIntegration',
    IstatAbruzzoExportIntegration = 'IstatAbruzzoExportIntegration',
    IstatCalabriaExportIntegration = 'IstatCalabriaExportIntegration',
    IstatCampaniaExportIntegration = 'IstatCampaniaExportIntegration',
    IstatFlorenceExportIntegration = 'IstatFlorenceExportIntegration',
    IstatFriuliExportIntegration = 'IstatFriuliExportIntegration',
    IstatLazioExportIntegration = 'IstatLazioExportIntegration',
    IstatLiguriaExportIntegration = 'IstatLiguriaExportIntegration',
    IstatLombardyExportIntegration = 'IstatLombardyExportIntegration',
    IstatPiemonteExportIntegration = 'IstatPiemonteExportIntegration',
    IstatPugliaExportIntegration = 'IstatPugliaExportIntegration',
    IstatSardiniaExportIntegration = 'IstatSardiniaExportIntegration',
    IstatSicilyExportIntegration = 'IstatSicilyExportIntegration',
    IstatTuscanyIntegration = 'IstatTuscanyIntegration',
    IstatValleDaostaExportIntegration = 'IstatValleDaostaExportIntegration',
    IstatVenetoExportIntegration = 'IstatVenetoExportIntegration',
    ItalianPoliceExportIntegration = 'ItalianPoliceExportIntegration',
    MilanTouristExportIntegration = 'MilanTouristExportIntegration',
    LuxembourgPoliceExportIntegration = 'LuxembourgPoliceExportIntegration',
    PortugalPoliceExportIntegration = 'PortugalPoliceExportIntegration',
    AndorraPoliceExportIntegration = 'AndorraPoliceExportIntegration',
    BasqueCountryPoliceExportIntegration = 'BasqueCountryPoliceExportIntegration',
    CataloniaPoliceAccommodationExportIntegration = 'CataloniaPoliceAccommodationExportIntegration',
    CataloniaPoliceCustomerProfilesExportIntegration = 'CataloniaPoliceCustomerProfilesExportIntegration',
    EuskalHerriaPoliceAccommodationExportIntegration = 'EuskalHerriaPoliceAccommodationExportIntegration',
    EuskalHerriaPoliceCustomerProfilesExportIntegration = 'EuskalHerriaPoliceCustomerProfilesExportIntegration',
    SpainPoliceAccommodationExportIntegration = 'SpainPoliceAccommodationExportIntegration',
    SpainPoliceCustomerProfilesExportIntegration = 'SpainPoliceCustomerProfilesExportIntegration',
    SpainPoliceExportIntegration = 'SpainPoliceExportIntegration',
    AvsBaselExportIntegration = 'AvsBaselExportIntegration',
    BaselPoliceExportIntegration = 'BaselPoliceExportIntegration',
    GenevaPoliceExportIntegration = 'GenevaPoliceExportIntegration',
    NidwaldenPoliceExportIntegration = 'NidwaldenPoliceExportIntegration',
    SwissHestaExportIntegration = 'SwissHestaExportIntegration',
    SwitzerlandPoliceExportIntegration = 'SwitzerlandPoliceExportIntegration',
    TicinoPoliceExportIntegration = 'TicinoPoliceExportIntegration',
    ZugPoliceExportIntegration = 'ZugPoliceExportIntegration',
    BobExportIntegration = 'BobExportIntegration',
    DatevExportIntegration = 'DatevExportIntegration',
    ExactOnlineExportIntegration = 'ExactOnlineExportIntegration',
    GrandBackExportIntegration = 'GrandBackExportIntegration',
    HeliosExportIntegration = 'HeliosExportIntegration',
    InfinitelEntryExportIntegration = 'InfinitelEntryExportIntegration',
    InfinitelInvoiceExportIntegration = 'InfinitelInvoiceExportIntegration',
    SageExportIntegration = 'SageExportIntegration',
    ExchangeRateProviderIntegration = 'ExchangeRateProviderIntegration',
    PassportScanIntegration = 'PassportScanIntegration',
    PassportScannerIntegration = 'PassportScannerIntegration',
    PrinterIntegration = 'PrinterIntegration',
    AdyenPaymentTerminalIntegration = 'AdyenPaymentTerminalIntegration',
    PaymentTerminalIntegration = 'PaymentTerminalIntegration',
    PayworksPaymentTerminalIntegration = 'PayworksPaymentTerminalIntegration',
    StripePaymentTerminalIntegration = 'StripePaymentTerminalIntegration',
    KeyCutterIntegration = 'KeyCutterIntegration',
    VostioKeyCutterIntegration = 'VostioKeyCutterIntegration',
    FiscalMachineIntegration = 'FiscalMachineIntegration',
    ConnectorIntegration = 'ConnectorIntegration',
    SmsIntegration = 'SmsIntegration',
    ChannelManagerIntegration = 'ChannelManagerIntegration',
    AnalyticsIntegration = 'AnalyticsIntegration',
    MewsBiIntegration = 'MewsBiIntegration',
}
